import React from "react";
import { Booking } from "../Interface";
import TimerList from "@/constants/TimerList";
import { format, parseISO } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import { ShowIcon } from "@/constants/utils/svgs";
import { FiEdit2 } from "react-icons/fi";
import { EVENT_TYPE_DATA } from "@/constants/Events";
import { timeToAmPm } from "@/helpers/TimeFormat";
import { getTimeDifference } from "@thdinc/hpf-shared";

interface EventsTableProps {
  pastEvents: Booking[];
  isPast?: boolean;
  openDetailView: (bookingId: string) => void;
}

const EventsTable: React.FC<EventsTableProps> = ({
  pastEvents,
  isPast,
  openDetailView,
}) => {
 
  return (
    <div>
      {pastEvents.length > 0 && (
        <div className="relative overflow-x-auto  rounded-2xl mt-4 overflow-y-auto max-h-full ">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500">
            <thead className="text-xs text-gray-700 uppercase bg-[#fcfdfd]">
              <tr>
                <th scope="col" className="px-2 sm:px-4  py-3">
                  NAME
                </th>
                <th scope="col" className="px-2 sm:px-4  py-3">
                  TIME
                </th>
                <th scope="col" className="px-2 sm:px-4  py-3">
                  DURATION
                </th>
                <th scope="col" className="px-2 sm:px-4  py-3">
                  DATE
                </th>
                <th scope="col" className="px-2 sm:px-4  py-3">
                  GUESTS
                </th>
                <th scope="col" className="px-2 sm:px-4  py-3">
                  TYPE
                </th>
                {!isPast && (
                  <th scope="col" className="px-2 sm:px-4  py-3">
                    BARTENDERS
                  </th>
                )}
                <th scope="col" className="px-2 sm:px-4  py-3">
                  STATUS
                </th>
              </tr>
            </thead>
            <tbody>
              {pastEvents.map((item: Booking, index) => {
                return (
                  <tr key={index} className="bg-white 0  border-b">
                    <td className="px-2 sm:px-4 py-4 min-w-44">
                      {/* <img className="h-14 w-14 object-cover rounded-full " src={item.image} /> */}
                      {`${item?.first_name} ${item.last_name}`}
                    </td>
                    <td className="px-2 sm:px-4 py-4 min-w-44">
                      {timeToAmPm(item.start_time, item.timezone) +
                        " - " +
                        timeToAmPm(item.end_time, item.timezone)}
                    </td>
                    <td className="px-2 sm:px-4 py-4 text-sm min-w-32">
                      {
                        getTimeDifference(
                          format(
                            toZonedTime(item.start_time, item.timezone),
                            "HH:mm"
                          ),
                          format(
                            toZonedTime(item.end_time, item.timezone),
                            "HH:mm"
                          )
                        ).hours
                      }{" "}
                      hr
                    </td>
                    <td className="px-2 sm:px-4 py-4  min-w-36">
                      <div className="cursor-pointer flex gap-3">
                        <div>{format(parseISO(item.start_time), "PPP")}</div>
                      </div>
                    </td>

                    <td className="px-2 sm:px-4 py-4  min-w-36">
                      <div className="cursor-pointer flex gap-3">
                        <div>{item.guests}</div>
                      </div>
                    </td>
                    <td className="px-2 sm:px-4 py-4  min-w-36">
                      <div className="cursor-pointer flex gap-3">
                        <p> {EVENT_TYPE_DATA &&
                      EVENT_TYPE_DATA.find(
                        (a: any) => a.value === item?.eventtype
                      )?.name}</p>
                      </div>
                    </td>
                    {!isPast && (
                      <td className="px-2 sm:px-4 py-4  min-w-36">
                        <div>
                          {item.auto_selected ? (
                            <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-300">
                              Auto Selected
                            </span>
                          ) : (
                            <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-300">
                              Selected
                            </span>
                          )}
                        </div>
                      </td>
                    )}
                    <td className="px-2 sm:px-4 py-4  w-full flex gap-8 items-center justify-between  ">
                      {item.auto_selected ? (
                        <div className="bg-[#fcd7d4] px-3  py-1 rounded-full">
                          <p className="text-[#FF6100] text-[10px] font-bold">
                            {" "}
                            Unassigned
                          </p>
                        </div>
                      ) : (
                        <div className="bg-[#ccf0eb] px-3  py-1 rounded-full">
                          <p className="text-[#00B69B] text-[10px] font-bold">
                            Assigned
                          </p>
                        </div>
                      )}
                      <div
                        className="cursor-pointer flex gap-3 bg-p-gray rounded-full p-2 "
                        onClick={() => openDetailView(item.id)}
                      >
                        <FiEdit2 size={14} />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default EventsTable;
